import { faqWidgetStyles } from "@iewccouk/Widgets/VerndaleBox/FaqWidget";

faqWidgetStyles.title = {
    variant: "h2",
};
